import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { ModalConfirmTemplate, useModalConfirm } from 'modules/modals/hooks';
import { ModalErrorText } from 'modules/modals/components/ModalErrorMessage';
import { policyGetDetailsAction } from 'modules/redux/states/policy/actions';
import { ROUTE } from 'modules/router/constants';
import { UseHandleError } from './types';

const useHandleError: UseHandleError = ({ dispatch, isError, policyId }) => {
  const { showModalConfirm } = useModalConfirm();
  const navigate = useNavigate();

  const handleError = useCallback(() => {
    if (showModalConfirm)
      showModalConfirm({
        onCancel: () => navigate(ROUTE.POLICY_SEARCH, { replace: true }),
        onConfirm: () => dispatch(policyGetDetailsAction({ policyId })),
        renderContent: () => (
          <ModalErrorText error={isError ? isError : undefined} />
        ),
        template: ModalConfirmTemplate.POLICY_DETAILS_ERROR,
      });
  }, [dispatch, isError, navigate, policyId, showModalConfirm]);

  useEffect(() => {
    if (isError) handleError();
  }, [handleError, isError]);
};

export default useHandleError;
